import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home.js';
import Apps from './pages/Apps.js';
import LabReport from './pages/LabReport.js';
import { ThemeProvider } from './ThemeContext.js';


function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route path="apps" element={<Apps />}/>          
          </Route>
          <Route path="/labs/:slug" element={<LabReport />}/>
          <Route path="*" element={<Home />}/>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
